export const START_FETCHING_ORDER_EVENT_HISTORY = 'START_FETCHING_ORDER_EVENT_HISTORY';
export const SUCCESS_FETCHING_ORDER_EVENT_HISTORY = 'SUCCESS_FETCHING_ORDER_EVENT_HISTORY';
export const ERROR_FETCHING_ORDER_EVENT_HISTORY = 'ERROR_FETCHING_ORDER_EVENT_HISTORY';

export const fetchOrderEventHistory = (dealerId, orderId) => {
  return (dispatch, getState, { api }) => {
    const success = ({ statusHistory }) =>
      dispatch({
        type: SUCCESS_FETCHING_ORDER_EVENT_HISTORY,
        dealerId,
        orderId,
        eventHistory: statusHistory,
      });

    const error = () =>
      dispatch({
        type: ERROR_FETCHING_ORDER_EVENT_HISTORY,
        dealerId,
        orderId,
      });

    dispatch({
      type: START_FETCHING_ORDER_EVENT_HISTORY,
      dealerId,
      orderId,
    });

    return api
      .fetchOrderEventHistory(dealerId, orderId)
      .then(success)
      .catch(error);
  };
};



// WEBPACK FOOTER //
// ./src/actions/order-event-history.js